// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_components__CopyButton from "../../../../../../../packages/components/src/CopyButton.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import ReactInfiniteScrollComponent from "react-infinite-scroll-component";
import * as JsxRuntime from "react/jsx-runtime";

function KbkTableView(Props) {
  let kbks = Props.kbks;
  const match = React.useState(function () {
    return /* [] */ 0;
  });
  const setDisplayData = match[1];
  const displayData = match[0];
  const match$1 = React.useState(function () {
    return true;
  });
  const setHasMore = match$1[1];
  const page = React.useRef(1);
  React.useEffect((function () {
    if (20 >= Stdlib__List.length(kbks)) {
      Curry._1(setDisplayData, (function (param) {
        return kbks;
      }));
    } else {
      Curry._1(setDisplayData, (function (param) {
        return Belt__Belt_Option.getWithDefault(Belt__Belt_List.take(kbks, 20), /* [] */ 0);
      }));
    }
    page.current = 1;
    Curry._1(setHasMore, (function (param) {
      return true;
    }));
  }), [kbks]);
  const loadMore = function (param) {
    if (Stdlib__List.length(displayData) >= Stdlib__List.length(kbks)) {
      Curry._1(setHasMore, (function (param) {
        return false;
      }));
    }
    page.current = page.current + 1 | 0;
    if (Math.imul(20, page.current) >= Stdlib__List.length(kbks)) {
      return Curry._1(setDisplayData, (function (param) {
        return kbks;
      }));
    } else {
      return Curry._1(setDisplayData, (function (param) {
        return Belt__Belt_Option.getWithDefault(Belt__Belt_List.take(kbks, Math.imul(20, page.current)), /* [] */ 0);
      }));
    }
  };
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("p", {
          children: "Код",
          className: "paragraph text-gray-light-landing"
        }),
        className: "pl-4 bg-gray-pale rounded-l-md py-1"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("p", {
          children: "Наименование",
          className: "paragraph text-gray-light-landing"
        }),
        className: "bg-gray-pale py-1 rounded-r-md pr-4"
      }),
      JsxRuntime.jsx(ReactInfiniteScrollComponent, {
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, kbk) {
          const Key = String(i);
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: /* Ru */ 1,
                  _2: {
                    TAG: /* Classifiers */ 8,
                    _0: {
                      TAG: /* Kbk */ 1,
                      _0: {
                        TAG: /* View */ 0,
                        _0: kbk.code
                      }
                    }
                  }
                },
                className: "px-4 py-2 group-hover:bg-divider rounded-l-md flex items-end gap-1",
                children: [
                  JsxRuntime.jsx("p", {
                    children: kbk.code,
                    className: "paragraph text-black-landing"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                      text: kbk.code
                    }),
                    className: "opacity-0 group-hover:opacity-100"
                  })
                ],
                scrollToTop: false
              }),
              JsxRuntime.jsxs(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: /* Ru */ 1,
                  _2: {
                    TAG: /* Classifiers */ 8,
                    _0: {
                      TAG: /* Kbk */ 1,
                      _0: {
                        TAG: /* View */ 0,
                        _0: kbk.code
                      }
                    }
                  }
                },
                className: "py-2 group-hover:bg-divider flex items-end gap-1 rounded-r-md pr-4",
                children: [
                  JsxRuntime.jsx("p", {
                    children: kbk.name,
                    className: "paragraph text-black-landing whitespace-nowrap overflow-hidden text-ellipsis"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                      text: kbk.name
                    }),
                    className: "opacity-0 group-hover:opacity-100 shrink-0"
                  })
                ],
                scrollToTop: false
              })
            ],
            className: "group contents"
          }, Key);
        }), displayData)),
        next: loadMore,
        hasMore: match$1[0],
        dataLength: Stdlib__List.length(displayData),
        className: "contents",
        scrollableTarget: "kbkScrollWrapper"
      })
    ],
    className: "hidden lg:grid grid-cols-[auto_800px] mt-4 overflow-y-auto content-start items-start",
    id: "kbkScrollWrapper"
  });
}

const rows = 20;

const make = KbkTableView;

export {
  rows,
  make,
}
/* Buhta_components__CopyButton Not a pure module */
